import React, { ReactNode, Suspense, useState } from 'react';
import { Layout } from 'antd';
import Header from '../components/Header';
import { containerStyle } from './MainContainer.style';
import Sidebar from '../components/Sidebar';
import { useTheme } from '../theme';
import useDeviceSize from '../hooks/useDeviceSize';
import Loading from '../components/Loading';

const { Content, Sider } = Layout;

type MainContainerProps = {
  children: ReactNode;
  fullscreen?: boolean;
};

export const MainContainer: React.FC<MainContainerProps> = ({ children, fullscreen }) => {
  const [sidebarActive, setSidebarActive] = useState(false);

  let device = useDeviceSize();
  let theme = useTheme();
  let style = containerStyle(theme, device);

  if (fullscreen) {
    return <Suspense fallback={<Content children={<Loading fullscreen={false} />} />}>{children}</Suspense>;
  }

  return (
    <Layout style={style.root} hasSider={false}>
      <Header toggleSider={setSidebarActive} isActive={sidebarActive} />
      <Layout style={style.main} hasSider={device.isDesktop ? true : false}>
        <Sider
          theme="light"
          style={{ margin: '0px 0px' }}
          children={<Sidebar isActive={sidebarActive} isMobile={!device.isDesktop} />}
        />
        <Suspense fallback={<Content children={<Loading fullscreen={false} />} />}>
          <Content children={children} />
        </Suspense>
      </Layout>
    </Layout>
  );
};
